import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import ExcelJS from 'exceljs'

function ExcelTableXLSX(props: any) {
  const setAMNBUSHeaders = () => {
    if (props.AMNBUSChecked) {
      return ['AMNBUS_URL', '货号', '日文名称', '中文名称', '成本(元/个)', '成本(日元/个)', '日元售价', '代理版(元/个)', '日版(元/个)', '每盒数量', '每箱数量', '截单日期', '发售日期']
    } else if (props.MATSUMURAChecked) {
      return ['MATSUMURA_URL', '货号', '日文名称', '中文名称', '成本(元/个)', '成本(日元/个)', '日元售价', '代理版(元/个)', '日版(元/个)', '每盒数量', '每箱数量', '截单日期', '发售日期']
    } else if (props.animalPresaleChecked) {
      return ["中文名称", "子分类", "单价(元/只)", "捆绑分类", "是否捆绑销售", "开启预售", "定金比例", "截单时间", "到货时间"]
    } else {
      return ['货号', '日文名称', '中文名称', '成本(元/个)', '成本(日元/个)', '日元售价', '代理版(元/个)', '日版(元/个)', '每盒数量', '每箱数量', '截单日期', '发售日期']
    }
  }

  let tableHeads = setAMNBUSHeaders()

  React.useEffect(() => {
    tableHeads = setAMNBUSHeaders()
  }, [props.AMNBUSChecked])

  return <TableContainer
    sx={props.sx}
  >
    <Table>
      <TableHead>
        <TableRow>
          {
            tableHeads.map((head, headIndex) =>
              <TableCell
                key={headIndex}
                sx={{
                  fontSize: '.4em',
                  minWidth: '1em',
                  maxWidth: '1em',
                  whiteSpace: 'nowrap',
                  borderLeft: 'solid 1px #ccc',
                  borderTop: 'solid 1px #ccc',
                  background: '#DCE6F1'
                }}
              >{head}</TableCell>
            )
          }
        </TableRow>
      </TableHead>
      <TableBody>

        {
          props.sheet?.getRows(2, props.sheet.rowCount - 1)?.map((row: ExcelJS.CellValue, row_index: number) =>
            <TableRow key={row_index}>
              {
                tableHeads.map((item: string, index: number) =>
                  <Tooltip title={(tableHeads[index] == "截单日期" || tableHeads[index] == "发售日期")
                    ? new Date(JSON.stringify((row as any)?.values[index + 1] ?? '')?.replaceAll("\"", '')).toLocaleDateString()
                    : ((row as any)?.values[index + 1] ?? '').toString()}>
                    <TableCell
                      key={index}
                      sx={{
                        p: 1,
                        fontSize: '.4em',
                        minWidth: '1em',
                        maxWidth: '1em',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        borderLeft: 'solid 1px #ccc'
                      }}
                    >
                      {
                        (tableHeads[index] == "截单日期" || tableHeads[index] == "截单时间" || tableHeads[index] == "到货时间" || tableHeads[index] == "发售日期") && (new Date(JSON.stringify((row as any)?.values[index + 1] ?? '')?.replaceAll("\"", '')).toLocaleDateString())
                      }
                      {
                        (tableHeads[index] != "截单日期" && tableHeads[index] != "截单时间" && tableHeads[index] != "到货时间" && tableHeads[index] != "发售日期") && ((row as any)?.values[index + 1]?.toString() == '[object Object]' ? (row as any)?.values[index + 1]?.richText.reduce((acc: string, cur: any) => acc + cur.text, "") : (row as any)?.values[index + 1]?.toString())
                      }
                    </TableCell>
                  </Tooltip>
                )
              }
            </TableRow>
          )
        }

      </TableBody>
    </Table>
  </TableContainer>
}

export default ExcelTableXLSX